import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonRadioGroup } from './RadioGroup.definition';
import { chameleonRadioButton } from '../RadioButton/RadioButton.definition';
import '@getgo/chameleon-typography/register/default';
provideChameleonDesignSystem().register(chameleonRadioGroup(), chameleonRadioButton());
